import { useContext } from 'react'
import { UseState } from '../utils/types'
import { JwtContext } from './context'
import { JWT } from './types'

export const useJwt = (): UseState<JWT | undefined> => {
  const { jwt, setJwt } = useContext(JwtContext)
  return [jwt, setJwt]
}
